import { render } from "./Video.vue?vue&type=template&id=25a6192f"
import script from "./Video.vue?vue&type=script&lang=js"
export * from "./Video.vue?vue&type=script&lang=js"

import exportComponent from "../../vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"@apostrophecms/vue-material-design-icons/Video.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "25a6192f"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('25a6192f', __exports__)) {
    api.reload('25a6192f', __exports__)
  }
  
  module.hot.accept("./Video.vue?vue&type=template&id=25a6192f", () => {
    api.rerender('25a6192f', render)
  })

}


export default __exports__